import React from 'react'

const RelatedTopics = ({ title, icon }) => {
  return (
    <div className='add-css-styling-cancel-div' style={{ cursor: 'pointer', marginBottom: '10px',display:'flex',alignItems:'center',gap:'8px'}}>
        <img src={icon} style={{ width: '1.4em', objectFit: 'contain' }} alt={title} />
        {/* Paragraph text ke liye Manrope font */}
        <h5 className='h5-heaidng-invouice' style={{ fontFamily: 'Manrope', fontSize: '15px' }}>
            {title}
        </h5>
    </div>
  )
}

export default RelatedTopics